import { createFileRoute, lazyRouteComponent } from "@tanstack/react-router"

export const Route = createFileRoute("/_authenticated/$slug/settings/units")({
  staticData: { title: "Units & display" },
  component: lazyRouteComponent(
    () => import("#pages/authenticated/settings/units.tsx"),
    "UnitsSettings",
  ),
})
